import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import {StudentAttendanceSummaryCard} from './StudentAttendanceSummaryCard.js';
import signals from './lib/signals.js';

export class StudentInfoForm {
	constructor(parent) {
		[this.el, this.$] = DojoTemplates('StudentInfoForm');
		this.parent = parent;
	}
	open(student) {
		this.parent.appendChild(this.el);
		this.$.title.textContent = `${student.Firstname} ${student.Surname}`;
		this.$.Surname.textContent = student.Surname;
		this.$.Firstname.textContent = student.Firstname;
		this.$.Mobile.href="tel:" + student.Mobile;
		this.$.Mobile.textContent = student.Mobile;
		this.$.Email.href = "mailto:" + student.Email;
		this.$.Email.textContent = student.Email;

		this.$.LastGrading.textContent = '...';
		this.$.ClassesSinceLastGrading.textContent = '...';
		
		let from = new Date();
		from.setMonth(from.getMonth()-1);
		DojoDeshi.instance().RPC().StudentAttendance(student.Id,
			/* default dojo */0, { From: from })
		.then(
			(res)=>{
				// console.log(`res = `, res);
				let div = document.createElement('div');
				// console.log(`Attendance = `, res[0].Attendance);
				for (let atr of res[0].Attendance) {
					// console.log(`creating new StudentAttendanceSummaryCard `, atr);
					new StudentAttendanceSummaryCard(div, this.student, atr);
				}
				this.$.Attendance.innerHTML='';
				this.$.Attendance.appendChild(div);
			})
		.catch(
			(err)=>{
				console.log(err);
				alert('ERR: ' + err.message);
			});

		DojoDeshi.instance().RPC().StudentAttendanceSearch({
			StudentId: student.Id,
			AttendanceTypeId: 4,	// Grading
		}).then(
			(res)=>{
				let [sa] = res;
				let countParams = {
					StudentId: student.Id
				};
				if (0==sa.Classes.length) {
					this.$.LastGrading.textContent = '- no last grading recorded -';
				} else {
					console.log(`Class0 = `, sa.Classes[0]);
					this.$.LastGrading.textContent = sa.Classes[0].Class.Start;
					this.$.LastGrading.setAttribute(`href`,`/classrecord/${sa.Classes[0].Class.Id}/edit`);
					countParams.DateRange = [ sa.Classes[0].Class.Start ];
				}
				DojoDeshi.instance().RPC().StudentAttendanceSearch(countParams)
				.then(
					(res)=>{
						console.log(`Count results are `, res);
						let count = 0;
						let weight = 0;
						for (let c of res[0].Classes) {
							count++;
							weight += c.Attendance.Weight;
						}
						this.$.ClassesSinceLastGrading.textContent = `${count} (weight ${weight})`;
					})
				.catch(
					(err)=>{
						console.log(err);
						alert(`ERR counting attendance: ${err.message}`);
					});
		})
		.catch(
			(err)=>{
				console.log(err);
				alert(`ERR: ${err.message}`);
			});
	}
}